/**
 * Get the current user from Redux store (persisted by Redux Persist)
 * Uses a lazy getter to avoid circular dependency issues
 * @returns {Object|null} Returns the user object if found, otherwise null
 */
let storeRef = null;

/**
 * Set the store reference (called from store.js after initialization)
 * This breaks the circular dependency by setting the store after it's created
 */
export const setStoreRef = (store) => {
  storeRef = store;
};

export const getUser = () => {
    try {
      if (!storeRef) {
        // Try to get store lazily if not set yet
        try {
          const storeModule = require("../redux/store");
          storeRef = storeModule.store;
        } catch (e) {
          // Store not available yet
          return null;
        }
      }
      
      const state = storeRef.getState();
      const user = state?.user;
      
      // Return null if user data is empty or invalid
      if (!user || !user.username || !user.email) {
        return null;
      }
      
      return user;
    } catch (error) {
      console.error("Failed to get user from Redux store:", error);
      return null; // return null in case of error
    }
};